import { notification } from "antd";
import { useState } from "react";
import { ExclamationCircleFilled } from '@ant-design/icons';
import confirm from "antd/es/modal/confirm";
import axiosInstance from "../../../../../../Services/axiosCommon";
import { ImportButton } from "../../../../../../Components/Utils/Buttons";
import { Modal } from "antd";

const ImportEstimationMaterial = ({ data, open, onCancel, getData, projectId }) => {
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const ImportMaterial = async (id, importvalue) =>  {
        setIsLoading(true);
        axiosInstance.post(`/material/${projectId}/import-from-estimation`)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              getData();
              api.success({
                message: "Success",
                description: res?.data?.msg || 'Imported successfully!',
                placement: 'bottomRight',
              });
              onCancel(); 
            } else {
              api.error({
                message: "Failed",
                description: res?.data?.msg || 'Network error',
                placement: 'bottomRight',
              });
            }
          })
          .catch((error) => {
            api.error({
              message: "Failed",
              description: error?.response?.data?.msg || 'Server error or Network issue',
              placement: 'bottomRight',
            });
          })
          .finally(() => {
            setIsLoading(false);
          });
      }


  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title=" Do You Want To Import Material From Estimation"
        width="35%"
        className="my-modal"
        centered
        onCancel={onCancel}
        footer={null}
      >
        <div className="flex  gap-4 ">
          {/* Import Button */}
          <button
            onClick={() => ImportMaterial(data?.title_ID, data?.title)}
            className={`px-5 py-2 text-white rounded-lg ${isLoading ? 'bg-red-300 cursor-wait' : 'bg-baseColor-primary'} `}
            disabled={isLoading}
          >
            {isLoading ? "Importing..." : "Import"}
          </button>

          {/* Cancel Button */}
          <button
            type="button"
            onClick={onCancel}
            className="px-5 py-2 text-textColor-main bg-[#E6F2F2] hover:bg-gray-300 rounded-md"
          >
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ImportEstimationMaterial;
